import { Inclusion } from "@/types";

interface TourInclusionsProps {
  type: "inclusions" | "exclusions";
  inclusions: Inclusion[];
}

const TourInclusions: React.FC<TourInclusionsProps> = ({
  inclusions,
  type,
}) => {
  if (inclusions.length === 0) {
    return (
      <ul className="space-y-4">
        <li className="flex items-start w-full">
          <div className="w-8 h-full flex items-center justify-center transform -translate-y-[1px]">
            <i className="far fa-circle-check text-neutral-700 bg-neutral-100 w-7 h-7 text-sm items-center flex justify-center rounded-full"></i>
          </div>
          <span className="w-[90%] text-sm text-neutral-600 font-[325] leading-[23px] ml-2">
            Nothing to see here!
          </span>
        </li>
      </ul>
    );
  }

  return (
    <ul className="space-y-4">
      {inclusions.map((inclusion, index) => (
        <li key={index} className="flex items-center w-full">
          <div className="w-8 h-full flex items-center justify-center transform -translate-y-[1px]">
            {type === "inclusions" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className="w-4 h-4 flex-shrink-0 fill-green-400 bg-green-200/50 rounded-full"
              >
                <path d="M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className="w-4 h-4 flex-shrink-0 fill-gray-400 bg-gray-200/50 rounded-full"
              >
                <path d="M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM180.7 180.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z" />
              </svg>
            )}
          </div>
          <span className="text-neutral-700 font-light text-[13px] leading-relaxed ml-1">
            {inclusion.otherDescription || inclusion.otherDescription === ""
              ? inclusion.otherDescription
              : "None!"}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default TourInclusions;
